<div class="sectionContainer paddedContent containerMargins">
  @if (!this.editingCatalog) {
    <div class="containerMargins">
      <input
        type="button"
        value="Create a Catalog"
        class="primary"
        style="cursor: pointer;"
        (click)="createCatalog()"
      />
    </div>

    <div class="containerMargins">
      @for (catalog of catalogs; track catalog.id) {
        <div
          style="
            margin-bottom: 10px;
            border: 1px solid #dddddd;
            border-radius: 4px;
            padding: 10px;
          "
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <div style="flex: 1">
              <div style="font-weight: bold">{{ catalog.name }}</div>
              <div style="font-size: 12px">{{ catalog.description }}</div>
            </div>
            @if (catalog.id) {
              <app-icon 
                [style]="'cursor: pointer; margin-right: 30px;'" title="Edit Catalog {{ catalog.name }}" [color]="'var(--color-action-icon)'"
                (click)="editCatalog(catalog.id)" type="Edit"
              ></app-icon>
              <app-icon [style]="'cursor: pointer;'" [title]="'Archive this catalog'" [color]="'var(--color-action-icon-delete)'"
                (click)="archiveCatalog(catalog)" type="Trash"
              ></app-icon>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (this.editingCatalog) {
    <div>
      <app-edit-catalog
        #editCatalogComponent
        [merchantId]="locationId"
        [catalogId]="selectedCatalogId"
        [catalogNames]="catalogs | mapToStringProp: 'name'"
        [mode]="FormMode.View"
        (saved)="handleCatalogSaved()"
        (cancelled)="handleCatalogCancelled()"
      ></app-edit-catalog>
    </div>
  }
</div>
